import React from 'react'
import styles from './ButtonContainer.module.css';


function ButtonContainer({ onButtonClick }) {


    const buttonList = [
        "C", "1", "2", "+", "3", "4", "-", "5", "6", "*", "7", "8", "/", "=", "9", "0", "."
    ];

    return (
        <div className={styles.buttonContainer} >
            {
                buttonList.map(buttonName => <button key={buttonName}  className={styles.button}
                    onClick={() => onButtonClick(buttonName)}
                >{buttonName}
                </button>)
            }
        </div>
    )
}

export default ButtonContainer